import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { userDevices } from '../mockData/user-devices-data';

const UserDevicesApi = [
  rest.get(`${API_ROOT}user-devices`, (req, res, ctx) => {
    const userId = req.url.searchParams.get('userId');
    if (userId === '1') {
      return res(ctx.json(userDevices));
    }
    return res(ctx.json([]));
  }),
  rest.get(`${API_ROOT}google`, (req, res, ctx) => {
    const integration = req.url.searchParams.get('integration');
    if (integration === 'googleFit') {
      return res(ctx.json({}));
    }
    return res(ctx.json({}));
  }),
];

export default UserDevicesApi;
